export const DELETE_CAR = 'lk/cars/delete'
export const ADD_CAR = 'lk/cars/create'
